import GenericField from '@shared/fields/generic-field';
import { ClubKitPieceModel } from './club-kit-piece-model';

export default class ClubKitField extends GenericField {
  constructor(name, label) {
    super();
    this.name = name;
    this.label = label;
    this.initialValue = Object.keys(ClubKitPieceModel.fields).reduce((result, field) => {
      result[field] = undefined;
      return result;
    }, {});
  }

  forPresenter(value) {
    return value || this.initialValue;
  }

  forFilterInitialValue(value) {
    return value || this.initialValue;
  }

  forFormInitialValue(value) {
    return value || this.initialValue;
  }

  forFilterCast() { }

  forFilterRules() { }

  forFormCast() { }

  forFormRules() { }
}